import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { signOut } from "@/lib/auth";
import { getMessageFromError } from "@/lib/utils";
import { useSentryError } from "@/store/sentry-error.context";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { toast } from "sonner";

const ErrorPage = () => {
  const { eventId } = useSentryError();

  const error = useRouteError();

  const errorMessage = (() => {
    if (isRouteErrorResponse(error)) {
      return `${error.status} ${error.statusText}`;
    } else if (error instanceof Error) {
      return getMessageFromError(error);
    } else if (typeof error === "string") {
      return error;
    }
    return "Error desconocido";
  })();

  const handleSignOut = async () => {
    try {
      await signOut();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      toast.error("Error al cerrar sesión", {
        description: getMessageFromError(error),
      });
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      id="error-page"
      className="flex h-full flex-col bg-[#262452] p-4 text-center"
    >
      <Card className="m-auto w-full max-w-2xl overflow-auto rounded-3xl p-4">
        <CardHeader>
          <CardTitle>Ocurrió un error inesperado</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-4 text-balance">{errorMessage}</p>

          {import.meta.env.DEV && (
            <details>
              <summary className="mb-2 font-bold">
                Detalles técnicos (solo en desarrollo)
              </summary>
              <pre className="whitespace-pre-wrap text-left text-xs">
                {error instanceof Error
                  ? error.stack
                  : JSON.stringify(error, null, 2)}
              </pre>
            </details>
          )}

          <p className="mt-6 flex flex-col items-center justify-center">
            <Button
              variant={"secondary"}
              className="mb-2"
              onClick={handleReload}
            >
              Recargar la página
            </Button>
            <Button variant={"link"} asChild>
              <Link to={"/"}>Ir a la página principal</Link>
            </Button>
            <Button variant={"link"} onClick={handleSignOut}>
              Cerrar sesión
            </Button>
          </p>

          {eventId && (
            <p className="mt-8 text-xs">
              Código de seguimiento: <code>{eventId}</code>
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorPage;
